function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { withDirectives as _withDirectives, vShow as _vShow, createVNode as _createVNode } from "vue";
import { reactive, Teleport, defineComponent } from "vue";
import { truthProp, unknownProp, getZIndexStyle, createNamespace, makeArrayProp } from "../utils";
import { DROPDOWN_KEY } from "../dropdown-menu/DropdownMenu";
import { useParent } from "@vant/use";
import { useExpose } from "../composables/use-expose";
import { Cell } from "../cell";
import { Icon } from "../icon";
import { Popup } from "../popup";

var _createNamespace = createNamespace("dropdown-item"),
    _createNamespace2 = _slicedToArray(_createNamespace, 2),
    name = _createNamespace2[0],
    bem = _createNamespace2[1];

var dropdownItemProps = {
  title: String,
  options: makeArrayProp(),
  disabled: Boolean,
  teleport: [String, Object],
  lazyRender: truthProp,
  modelValue: unknownProp,
  titleClass: unknownProp
};
var stdin_default = defineComponent({
  name: name,
  props: dropdownItemProps,
  emits: ["open", "opened", "close", "closed", "change", "update:modelValue"],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
        slots = _ref.slots;
    var state = reactive({
      showPopup: false,
      transition: true,
      showWrapper: false
    });

    var _useParent = useParent(DROPDOWN_KEY),
        parent = _useParent.parent,
        index = _useParent.index;

    if (!parent) {
      if (process.env.NODE_ENV !== "production") {
        console.error("[Vant] <DropdownItem> must be a child component of <DropdownMenu>.");
      }

      return;
    }

    var getEmitter = function getEmitter(name2) {
      return function () {
        return emit(name2);
      };
    };

    var onOpen = getEmitter("open");
    var onClose = getEmitter("close");
    var onOpened = getEmitter("opened");

    var onClosed = function onClosed() {
      state.showWrapper = false;
      emit("closed");
    };

    var onClickWrapper = function onClickWrapper(event) {
      if (props.teleport) {
        event.stopPropagation();
      }
    };

    var toggle = function toggle() {
      var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !state.showPopup;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (show === state.showPopup) {
        return;
      }

      state.showPopup = show;
      state.transition = !options.immediate;

      if (show) {
        state.showWrapper = true;
      }
    };

    var renderTitle = function renderTitle() {
      if (slots.title) {
        return slots.title();
      }

      if (props.title) {
        return props.title;
      }

      var match = props.options.find(function (option) {
        return option.value === props.modelValue;
      });
      return match ? match.text : "";
    };

    var renderOption = function renderOption(option) {
      var activeColor = parent.props.activeColor;
      var active = option.value === props.modelValue;

      var onClick = function onClick() {
        state.showPopup = false;

        if (option.value !== props.modelValue) {
          emit("update:modelValue", option.value);
          emit("change", option.value);
        }
      };

      var renderIcon = function renderIcon() {
        if (active) {
          return _createVNode(Icon, {
            "class": bem("icon"),
            "color": activeColor,
            "name": "success"
          }, null);
        }
      };

      return _createVNode(Cell, {
        "role": "menuitem",
        "key": option.value,
        "icon": option.icon,
        "title": option.text,
        "class": bem("option", {
          active: active
        }),
        "style": {
          color: active ? activeColor : ""
        },
        "tabindex": active ? 0 : -1,
        "clickable": true,
        "onClick": onClick
      }, {
        value: renderIcon
      });
    };

    var renderContent = function renderContent() {
      var offset = parent.offset;
      var _parent$props = parent.props,
          zIndex = _parent$props.zIndex,
          overlay = _parent$props.overlay,
          duration = _parent$props.duration,
          direction = _parent$props.direction,
          closeOnClickOverlay = _parent$props.closeOnClickOverlay;
      var style = getZIndexStyle(zIndex);

      if (direction === "down") {
        style.top = "".concat(offset.value, "px");
      } else {
        style.bottom = "".concat(offset.value, "px");
      }

      return _withDirectives(_createVNode("div", {
        "style": style,
        "class": bem([direction]),
        "onClick": onClickWrapper
      }, [_createVNode(Popup, {
        "show": state.showPopup,
        "onUpdate:show": function onUpdateShow($event) {
          return state.showPopup = $event;
        },
        "role": "menu",
        "class": bem("content"),
        "overlay": overlay,
        "position": direction === "down" ? "top" : "bottom",
        "duration": state.transition ? duration : 0,
        "lazyRender": props.lazyRender,
        "overlayStyle": {
          position: "absolute"
        },
        "aria-labelledby": "".concat(parent.id, "-").concat(index.value),
        "closeOnClickOverlay": closeOnClickOverlay,
        "onOpen": onOpen,
        "onClose": onClose,
        "onOpened": onOpened,
        "onClosed": onClosed
      }, {
        "default": function _default() {
          var _a;

          return [props.options.map(renderOption), (_a = slots["default"]) == null ? void 0 : _a.call(slots)];
        }
      })]), [[_vShow, state.showWrapper]]);
    };

    useExpose({
      state: state,
      toggle: toggle,
      renderTitle: renderTitle
    });
    return function () {
      if (props.teleport) {
        return _createVNode(Teleport, {
          "to": props.teleport
        }, {
          "default": function _default() {
            return [renderContent()];
          }
        });
      }

      return renderContent();
    };
  }
});
export { stdin_default as default };